import { scrollToComponentModule } from '../scroll-to/scroll-to';

export const scrollOnFocusDirectiveModule = angular
  .module('Q.components.scroll-on-focus', [scrollToComponentModule])

  .directive('scrollOnFocus', function () {
    return {
      restrict: 'A',
      controller: 'ScrollOnFocusCtrl',
    };
  })

  // Note: Controllers usually imply an integrated component, you probably want to use a component instead of
  // a full directive, unless you need lots of DOM manipulation
  .controller(
    'ScrollOnFocusCtrl',
    function ScrollOnFocusCtrl($element, scrollToElement) {
      const ctrl = this;
      ctrl.check = ($elem) => {
        // we check for labels as well, to make sure the entire input control is visible
        const $label = $element.querySelector(
          `label[for="${$elem.attr('id')}"]`,
        );
        if (!$elem.isInView() || ($label.length && !$label.isInView())) {
          // scroll the label (preferred) or the element into view, and position 25% from the top
          scrollToElement({
            target: $label.length ? $label : $elem,
            center: 0.25,
          });
        }
      };
    },
  )

  .directive('input', scrollOnFocusInputDirective)
  .directive('select', scrollOnFocusInputDirective)
  .directive('textarea', scrollOnFocusInputDirective);

/* @ngInject */
function scrollOnFocusInputDirective() {
  return {
    restrict: 'E',
    require: '^^?scrollOnFocus',
    link(scope, $elem, attr, scrollOnFocusCtrl) {
      if (scrollOnFocusCtrl) {
        $elem.on('focus', () => {
          scrollOnFocusCtrl.check($elem);
        });
      }
    },
  };
}
